import React, {Component} from 'react';

export default class Number extends Component {

    onBlur = (event) => {
        const {
            name,
        } = this.props.params;

        const value = event.target.value;

        if (value) {
            this.props.setField(
                name,
                value,
                '',
            );

            return;
        }

        if (
            this.props.state.fields[name].role.required
        ) {
            this.props.setField(
                name,
                value,
                'Kötelező megadni',
            );
        }
    };

    onChange = (event) => {
        const value = event.target.value;

        if (
            value.indexOf('<') < 0
            && value.indexOf('>') < 0
        ) {
            this.props.setField(
                this.props.params.name,
                value,
            );
        }
    };

    render() {
        const {
            params,
            state,
        } = this.props;

        const field = state.fields[params.name];

        const hasError = field.error
            ? 'has-error'
            : '';

        return (
            <div
                className={
                    `field field-text ${params.id} ${hasError}`
                }
                style={params.style}
            >
                <div>
                    <label
                        htmlFor={params.id}
                        className={params.classLabel}
                    >
                        {params.label}
                    </label>

                    <input
                        type="number"
                        spellCheck="false"
                        autoComplete="off"
                        min="0"
                        max="500000"
                        id={params.id}
                        className={params.classInput}
                        name={params.name}
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                        value={field.value || ''}
                        disabled={params.disabled}
                    />

                    <p className="help-block help-block-error">
                        {field.error ? (
                            <span className="error">
                                <i className="fa fa-warning" />
                                {' '}
                                {field.error}
                            </span>
                        ) : null}
                    </p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/fields/Number.js